export default ({
  element: {
    data: {
      url,
    },
  },
}) => (
  !url
)
